<template>
  <div>
    <div class="columns">
      <div class="column is-5">
        <img v-if="slip.document" v-document="slip.document" class="full-width smooth-corners">
      </div>

      <div class="column">
        <div class="field">
          <label class="label">Chauffeur</label>
          <div class="control">
            <input class="input" type="text" :value="crediteur" disabled>
          </div>
        </div>

        <div class="field">
          <label class="label">Bonnummer</label>
          <div class="control">
            <input class="input" type="text" :value="number" disabled>
          </div>
        </div>

        <div class="field">
          <label class="label">Datum</label>
          <div class="control">
            <input class="input" type="text" :value="date | date('DD/MM/YYYY')" disabled>
          </div>
        </div>

        <div class="field">
          <label class="label">Creditcard</label>
          <div class="control">
            <input class="input" type="text" :value="creditcard.name" disabled>
          </div>
        </div>

        <div class="field">
          <label class="label">Grootboekrekening</label>
          <div class="control">
            <input class="input" type="text" :value="journal" disabled>
          </div>
        </div>

        <div class="field">
          <label class="label">Prijs</label>
          <div class="control has-icons-left">
            <input class="input" type="number" :value="price" disabled>
            <span class="icon is-left">
              <i class="fa fa-eur"></i>
            </span>
          </div>
        </div>

        <div class="spacing-top-20">
          <button class="button is-danger" @click="reject">Afkeuren</button>
          <button class="button is-primary" @click="confirm">Goedkeuren</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters([
      'debiteuren',
      'crediteuren',
      'creditcardCompanies'
    ]),
    ...mapGetters({
      creditcardslips: 'allCreditcardslips',
      incomplete: 'incompleteCreditcardslips',
      journals: 'creditcardslipsJournals'
    })
  },
  data () {
    return {
      slip: {},
      crediteur: '',
      number: '',
      date: '',
      creditcard: {},
      journal: '',
      price: null
    }
  },
  async created () {
    await this.$store.dispatch('getAllCreditcardslips')
    await this.$store.dispatch('getCrediteuren')
    await this.$store.dispatch('getCreditcardCompanies')
    await this.$store.dispatch('getCreditcardslipsJournals')

    const id = this.$route.params.id
    const slip = this.creditcardslips.find((slip) => slip.id === id)

    this.slip = slip
    let {number, date, creditcard, crediteur, journal, price} = this.slip

    this.number = number
    this.date = date ? new Date(date) : new Date()
    this.creditcard = creditcard
    this.journal = journal
    this.price = price

    this.setCrediteur(crediteur)
  },
  methods: {
    async reject () {
      await this.$store.dispatch('setCreditcardslipState', {
        id: this.slip.id,
        state: 'incomplete'
      })

      this.$router.push({ name: 'creditcard.confirmation' })
    },
    async confirm () {
      await this.$store.dispatch('setCreditcardslipState', {
        id: this.slip.id,
        state: 'confirmed'
      })

      this.$router.push({ name: 'creditcard.confirmation' })
    },
    async saveCreditcardslip () {
      const { id } = this.slip
      const { date, creditcard, journal, price } = this

      await this.$store.dispatch('saveCreditcardslip', {
        id,
        date,
        creditcard,
        journal,
        crediteur: this.crediteur.selected,
        price
      })

      this.$router.push({ name: 'creditcard.processing' })
    },
    setCrediteur (id) {
      for (let object of this.crediteuren) {
        if (object.subNr === id) {
          this.crediteur = object.acctName
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/creditcard/confirmation/edit.vue